<template>
  <div>
    <div class="d-flex">
      <h2 class="title ont-weight-bold align-center">Content Editor</h2>
      <v-spacer />
      <a-phone-modal :messages="generateMessages" class="d-none d-md-flex">
        <template v-slot:activator="{ on }">
          <v-btn
            depressed
            color="blue white--text ml-auto d-none d-md-flex"
            v-on="on"
            >Preview Course</v-btn
          >
        </template>
      </a-phone-modal>
    </div>
    <!-- Show tabs on top for mobile devices only -->
    <v-tabs show-arrows class="d-md-none d-lg-none d-xl-none">
      <v-tabs-slider></v-tabs-slider>
      <v-tab v-for="x in days" :key="x._id" @click="selected = String(x._id)">{{
        x.day
      }}</v-tab>
    </v-tabs>
    <!-- Mobile Warning -->
    <p class="mt-3 d-md-none d-lg-none d-xl-none">
      <v-icon color="red lighten-2">mdi-alert</v-icon>You are viewing a
      simplified version of this editor. In order to get the full view, please
      switch to a larger screen.
    </p>
    <!-- General Alerts -->
    <p class="mt-3" v-if="globalerrormessage != ''">
      <v-icon color="orange lighten-2">mdi-alert</v-icon>
      {{ globalerrormessage }}
    </p>
    <!-- This is for the content -->
    <div id="editor" class="pt-3">
      <!-- Left side menu from md-large devices only -->
      <div>
        <v-card
          flat
          outlined
          class="column left d-none d-md-flex flex-column sidebar pa-2 mr-4"
        >
          <draggable
            class="list-group"
            style="width:100%"
            tag="div"
            handle=".handle"
            v-model="days"
            v-bind="dragOptions"
            @start="drag = true"
            :move="onDayMove"
            @end="updateDayOrder"
          >
            <!-- <transition-group
              type="transition"
              :name="!drag ? 'flip-list' : null"
            > -->
            <v-card
              class="list-group-item mt-1 pa-2"
              style="width:100%"
              :color="selected == String(element._id) ? 'blue lighten-3' : ''"
              v-for="element in days"
              :key="String(element._id)"
              outlined
              flat
              @click="selected = String(element._id)"
            >
              <v-container class="pa-0 align-center" fluid>
                <v-row no-gutters style="flex-wrap: nowrap;">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title class="body-1"
                      >{{ element.day }}
                      {{
                        element.subject ? " - " + element.subject : ""
                      }}</v-list-item-title
                    >
                  </v-list-item-content>
                  <v-icon
                    v-show="unsaved.includes(element._id)"
                    class="icon"
                    color="red"
                    title="Save your changes now!"
                    >mdi-content-save</v-icon
                  >
                  <v-btn
                    text
                    icon
                    class="trash"
                    x-small
                    v-if="showDraftOptions"
                    @click.stop="onDayDeleteAsk(element)"
                  >
                    <v-icon class="icon" size="20">mdi-delete</v-icon>
                  </v-btn>
                  <v-icon class="handle" size="20" v-if="showDraftOptions"
                    >mdi-drag-horizontal</v-icon
                  >
                </v-row>
              </v-container>
            </v-card>
            <!-- </transition-group> -->
          </draggable>
          <v-btn
            class="fixed-add mt-2"
            fab
            dark
            depressed
            color="blue"
            x-small
            @click="addDay"
            v-if="!(days.length == 0) && showDraftOptions"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
          <v-btn
            class="ma-2"
            tile
            dark
            color="blue"
            @click="addDay"
            v-if="days.length == 0 && showDraftOptions"
          >
            <v-icon left>mdi-pencil</v-icon> Add a day
          </v-btn>
        </v-card>
        <v-card
          class="pa-2 mr-4 mt-4 column left d-none d-md-flex flex-column sidebar "
          flat=""
          outlined=""
        >
          <h3 class="align-center">FAQ</h3>
          <section class="mt-2">
            <p class="pb-0 mb-0"><b>Writing Guide</b></p>
            <p>
              Get started quickly by going to
              <a href="https://lrn.st/guide" text target="__learning_guide"
                >Arist's writing guide.</a
              >
            </p>
          </section>
          <section class="mt-2">
            <p class="pb-0 mb-0"><b>Website Links</b></p>
            <p>
              Putting a full URL in the text, e.g. http://www.example.com, will
              result in the users phone automatically converting it into a link.
            </p>
          </section>
          <section class="mt-2">
            <p class="pb-0 mb-0"><b>Emojis</b></p>
            <p>
              Emojis can be copied and pasted into any text field. Your phone
              will automatically convert it!
            </p>
          </section>
          <section class="mt-2">
            <p class="pb-0 mb-0"><b>Support</b></p>
            <p>
              Visit
              <a href="https://arist.co/support" target="__arist"
                >www.arist.co/support</a
              >
              for more help.
            </p>
          </section>
        </v-card>
      </div>
      <!-- The actual editor -->
      <div v-if="!selected">
        <p>
          <span class=""
            ><v-icon color="grey" small="">mdi-information</v-icon> Select a day
            to start editing content.</span
          >
        </p>
        <p class="ml-5">
          Not sure how to get started? We made an Arist Onboarding course just
          for you!
        </p>
        <p class="ml-5">
          <a href="http://lrn.st/onboard" target="__aristonboarding__">
            Take me there 🚀
          </a>
        </p>
      </div>

      <div class style="width:100%" v-show="selected">
        <h2>Edit Day {{ selectedday.day }}</h2>
        <v-layout row wrap>
          <!-- Header information of text message -->
          <v-flex class="col-12">
            <div class="d-flex align-center">
              <h3 class="pb-2 align-center">Media</h3>
              <v-spacer />
              <div>
                <v-btn
                  class="ma-2 d"
                  depressed
                  dark
                  v-if="selectedday.imglink"
                  @click="selectedday.imglink = ''"
                  color="grey"
                  min-width="200px"
                >
                  <v-icon left>mdi-delete</v-icon>Remove Media File
                </v-btn>
                <v-btn
                  class="ma-2"
                  dark
                  v-if="!selectedday.imglink"
                  depressed
                  @click="imageModal = true"
                  color="blue"
                  min-width="200px"
                >
                  <v-icon left>mdi-image</v-icon>Add Media File
                </v-btn>
              </div>
            </div>
            <v-card class="pa-2" v-if="selectedday.imglink" flat outlined="">
              <v-container fluid>
                <v-row align="center" justify="center">
                  <v-col class="col-12 justify-center align-center">
                    <div style="width:100%">
                      <img
                        :src="selectedday.imglink"
                        class="custom-img"
                        contain
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
            <p class="body-1 text-center" v-if="!selectedday.imglink">
              You currently don't have an image attached to this day. This will
              default to Arist's logo.
            </p>
          </v-flex>
          <v-flex class="col-12">
            <h3 class="pb-2">Content</h3>
            <v-card class="pa-2" flat outlined>
              <v-text-field
                autocomplete="off"
                spellcheck="true"
                label="Subject"
                clearable
                dense
                :prefix="`Day ${selectedday.day} - `"
                v-model="selectedday.subject"
                hint="For example, Introduction to US History"
                :maxlength="1200 - `${selectedday.content}`.length"
              ></v-text-field>
              <!-- <p class="subtitle-2 mb-0">Body of Message</p> -->
              <!-- <textarea
                class="temp-textarea"
                rows="4"
                v-model="selectedday.content"
              ></textarea> -->
              <v-textarea
                autocomplete="off"
                spellcheck="true"
                name="input-body-content"
                label="Body of Message"
                no-resize
                v-model="selectedday.content"
                rows="15"
                value
                dense
              ></v-textarea>
              <!--                 :maxlength="1200 - `${selectedday.subject}`.length" -->
              <v-card-subtitle
                class="pa-0 ma-0"
                v-bind:class="{
                  'orange--text':
                    String(selectedday.content).length +
                      String(selectedday.subject).length >=
                      1000 &&
                    String(selectedday.content).length +
                      String(selectedday.subject).length <=
                      1200,
                  'red--text':
                    String(selectedday.content).length +
                      String(selectedday.subject).length >
                    1200
                }"
              >
                {{
                  String(selectedday.content).length +
                    String(selectedday.subject).length
                }}
                / 1200 characters
              </v-card-subtitle>
            </v-card>
          </v-flex>
          <!-- Assessment part of module -->
          <v-flex class="col-12">
            <div class="d-flex align-center">
              <h3 class="pb-2 align-center">Questions</h3>
              <v-spacer />
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="ma-2 d-none d-md-flex"
                    depressed
                    dark
                    color="blue"
                    v-on="on"
                    min-width="200px"
                  >
                    <v-icon left>mdi-clipboard-plus</v-icon> Add Question
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="addAssessment(selectedday, 'choice')">
                    <v-list-item-title>Multiple Choice</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addAssessment(selectedday, 'short')">
                    <v-list-item-title>One Word Answer</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addAssessment(selectedday, 'open')">
                    <v-list-item-title>Open Ended</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <template v-for="(assessment, index) in selectedday.assessments">
              <template v-if="assessment.type == 'choice'">
                <!-- Could use component tag here -->
                <a-l-optionsassessment
                  :key="assessment._id"
                  :assessment="assessment"
                  @assessmentChange="alert('')"
                  @delete="assessmentDelete(index)"
                />
              </template>
              <template v-if="assessment.type == 'short'">
                <a-l-shortassessment
                  :key="assessment._id"
                  :assessment="assessment"
                  @assessmentChange="alert('')"
                  @delete="assessmentDelete(index)"
                />
              </template>
              <template v-if="assessment.type == 'open'">
                <a-l-openassessment
                  :key="assessment._id"
                  :assessment="assessment"
                  @assessmentChange="alert('')"
                  @delete="assessmentDelete(index)"
                />
              </template>
            </template>
          </v-flex>
          <v-flex class="col-12" style="position: relative;">
            <p class="caption mb-0">ID: {{ selectedday._id }}</p></v-flex
          >
        </v-layout>
      </div>
    </div>
    <!-- End Content Editor -->
    <!-- Confirm the day to be deleted -->
    <a-confirm-modal :dialog="deleteDayModal">
      <template slot="headline">
        Are you sure you want to delete Day {{ deleteDayNumber }}?
      </template>
      <template slot="body">
        This action cannot be undone, and is <b>saved immediately</b> to the
        draft.
      </template>
      <template slot="actions">
        <v-btn color="grey" dark depressed @click="onDayDeleteReject"
          >Cancel</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn depressed color="red lighten-2" dark @click="onDayDeleteConfirm"
          >Yes, Delete and Save</v-btn
        >
      </template>
    </a-confirm-modal>
    <!-- End Confirm Modal -->
    <!-- Start Delete Error Modal -->
    <a-confirm-modal :dialog="dayDeleteErrorModal">
      <template slot="headline">
        Unable to delete the selected day!
      </template>
      <template slot="body">
        Sorry, but we couldn't delete the day you selected. Please try again
        later.
      </template>
      <template slot="actions">
        <v-spacer></v-spacer>
        <v-btn depressed color="blue" dark @click="dayDeleteErrorModal = false"
          >Dismiss</v-btn
        >
      </template>
    </a-confirm-modal>
    <!-- End Modal -->
    <!-- Start Delete Error Modal -->
    <a-confirm-modal :dialog="deletehandler.assessment.modal">
      <template slot="headline">
        Are you sure you want to delete this {{ deleteAssessment }}?
      </template>
      <template slot="body">
        Once saved, this action cannot be undone.
      </template>
      <template slot="actions">
        <v-btn color="grey" dark depressed @click="onAssessmentDeleteReject"
          >Cancel</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          depressed
          color="red lighten-2"
          dark
          @click="onAssessmentDeleteConfirm"
          >Yes, Delete Assessment</v-btn
        >
      </template>
    </a-confirm-modal>
    <!-- End Modal -->
    <a-image-modal
      :dialog="imageModal"
      @close="imageModal = false"
      @finish="onMediaPick"
    />
  </div>
</template>
<style scoped>
.custom-img {
  width: 100%;
  max-height: 150px;
  object-fit: contain;
  margin-left: auto;
  margin-right: auto;
}
</style>
<script>
import phonemodal from "@/components/mock-phone-modal";
import draggable from "vuedraggable";

import optionsAssessment from "./components/optionsassessments";
import shortAssessment from "./components/shortanswerassessment";
import openAssessment from "./components/openassessment";
import services from "@/services/index.js";

import confirmModal from "@/components/confirmation-modal";

import imageModal from "@/components/imagedisplay-modal";

export default {
  components: {
    draggable,
    "a-l-optionsassessment": optionsAssessment,
    "a-l-shortassessment": shortAssessment,
    "a-l-openassessment": openAssessment,
    "a-confirm-modal": confirmModal,
    "a-image-modal": imageModal,
    "a-phone-modal": phonemodal
  },
  props: {
    courseid: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: false
    },
    saveindex: {
      type: Number,
      required: false,
      default: () => {
        return 0;
      }
    },
    clearindex: {
      type: Number,
      required: false,
      default: () => {
        return 0;
      }
    }
  },
  data: () => ({
    previewCourse: false,
    imageModal: false,
    drag: false,
    globalerrormessage: "",
    days: [],
    unsaved: [],
    direction: "left",
    selected: null,
    selectedDeleteDay: null,
    deleteDayModal: false,
    dayDeleteErrorModal: false,
    transition: "slide-y-reverse-transition",
    dragupdates: [],
    deleteAssessmentModal: false,
    deletehandler: {
      assessment: {
        selected: null,
        modal: false
      }
    }
  }),
  computed: {
    generateMessages() {
      try {
        let messages = [];
        this.days.forEach((data, index) => {
          messages.push({
            type: "line",
            text: `Day ${index + 1}`
          });
          messages.push({
            type: "image",
            text: `${data.imglink}`
          });
          messages.push({
            type: "yours",
            text: `Day ${index + 1} - ${data.subject}\n\n${data.content}${
              data.assessments && data.assessments.length > 0
                ? "\n\n---\n" + data.assessments[0].question
                : ""
            }`
          });
        });
        return messages;
      } catch (err) {
        return [];
      }
    },
    deleteDayNumber() {
      if (!this.selectedDeleteDay) {
        return "None";
      }
      return String(this.selectedDeleteDay.day);
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    selectedday: {
      get() {
        if (this.selected == null) {
          return {};
        }
        /**
         * @type {Array}
         */
        let days = this.days;
        let f = days.filter(x => {
          return x._id == this.selected;
        });
        return f.pop();
      }
    },
    showDraftOptions() {
      return this.type == "writer";
    },
    deleteAssessment() {
      //No selected assessment to delete
      if (this.deletehandler.assessment.selected == null) {
        return "";
      }
      //no selected day
      if (this.selectedday == null) {
        return "";
      }
      if (!Array.isArray(this.selectedday.assessments)) {
        return "";
      }
      if (
        this.selectedday.assessments[this.deletehandler.assessment.selected] ==
        undefined
      ) {
        return "";
      }
      switch (
        this.selectedday.assessments[this.deletehandler.assessment.selected]
          .type
      ) {
        case "choice":
          return "Multiple Choice Assessment";
        case "short":
          return "Short Answer";
        case "open":
          return "Open Ended Question";
        default:
          return "";
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log("Checkout route....");
    if (this.unsaved.length == 0) {
      next();
      return;
    }
    try {
      this.$ga.event({
        eventCategory: "dashboard-course-editor",
        eventAction: "attempt-no-save",
        eventLabel: "Dashboard"
      });
    } catch (err) {
      console.error("[GA]", err);
    }
    if (
      confirm(
        "Are you sure you want to leave?\n\nYou have unsaved changes, which cannot be recovered."
      )
    ) {
      try {
        this.$ga.event({
          eventCategory: "dashboard-course-editor",
          eventAction: "accept-no-save",
          eventLabel: "Dashboard"
        });
      } catch (err) {
        console.error("[GA]", err);
      }
      return next();
    } else {
      // GA Analytics
      try {
        this.$ga.event({
          eventCategory: "dashboard-course-editor",
          eventAction: "reject-no-save",
          eventLabel: "Dashboard"
        });
      } catch (err) {
        console.error("[GA]", err);
      }
      // End GA Analytics
      next(false);
    }
  },
  watch: {
    days: {
      handler(val) {
        if (this.selected == null) {
          return;
        }
        if (this.unsaved.includes(this.selected)) {
          return;
        }
        console.log("Adding ", this.selected, "to unsaved");
        this.unsaved.push(String(this.selected));
      },
      deep: true
    },
    unsaved() {
      if (!(this.unsaved.length != 0)) {
        return;
      }
      this.$emit("edited");
    },
    saveindex() {
      let unsaved_docs = this.days.filter(obj => {
        return this.unsaved.includes(String(obj._id));
      });
      this.$emit("save", unsaved_docs);
      this.$emit("save", this.dragupdates);
    },
    clearindex() {
      console.log("CLEARING");
      this.unsaved = [];
      this.dragupdates = [];
    }
  },
  methods: {
    /*
              :move="onDayMove"
            @end="updateDayOrder"
    */
    onDayMove() {},
    onMediaPick(image) {
      // GA Analytics
      try {
        this.$ga.event({
          eventCategory: "dashboard-course-editor",
          eventAction: "add-media",
          eventLabel: "Dashboard"
        });
      } catch (err) {
        console.error("[GA]", err);
      }
      // End GA Analytics
      this.selectedday.imglink = image.Location;
      this.imageModal = false;
    },
    async updateDayOrder() {
      console.log(this.type);
      if (this.type != "writer") {
        return;
      }
      console.log("Updating draft order...");
      this.drag = false;
      this.dragupdates = await this.correctDayOrder();
      if (this.dragupdates.length == 0) {
        return;
      }
      this.$emit("edited");
    },
    /**
     * Adds an assessment to the selected day.
     */
    addAssessment(day, type) {
      if (!["choice", "open", "short"].includes(String(type))) {
        return;
      }
      // GA Analytics
      try {
        this.$ga.event({
          eventCategory: "dashboard-course-editor",
          eventAction: "add-assessment",
          eventLabel: "Dashboard"
        });
      } catch (err) {
        console.error("[GA]", err);
      }
      // End GA Analytics
      if (day.assessments == undefined) {
        day.assessments = [];
      }
      day.assessments.push({
        question: "",
        type: type,
        options: [],
        answer: "",
        response: ""
      });
    },
    /**
     * Handles when the assessment want's to be deleted.
     */
    assessmentDelete(index) {
      this.deletehandler.assessment.selected = index;
      this.deletehandler.assessment.modal = true;
    },
    onAssessmentDeleteConfirm() {
      // GA Analytics
      try {
        this.$ga.event({
          eventCategory: "dashboard-course-editor",
          eventAction: "delete-assessment",
          eventLabel: "Dashboard"
        });
      } catch (err) {
        console.error("[GA]", err);
      }
      // End GA Analytics
      this.selectedday.assessments.splice(
        this.deletehandler.assessment.selected,
        1
      );
      this.onAssessmentDeleteReject();
    },
    onAssessmentDeleteReject() {
      this.deletehandler.assessment.selected = null;
      this.deletehandler.assessment.modal = false;
    },
    /**
     * Loads all the content required.
     */
    async onLoad() {
      this.$store.commit("setLoading", true);
      try {
        let days = await services.day.get({
          id: this.courseid,
          type: this.type
        });
        this.days = days;
      } catch (err) {
        console.error("There was an error fetching days", err);
      }
      this.$store.commit("setLoading", false);
    },
    /**
     * Handles creating a new day.
     */
    async addDay() {
      this.$store.commit("setLoading", true);
      try {
        let day = await services.day.create({
          id: this.courseid,
          type: this.type
        });
        this.days.push(day);
        // GA Analytics
        try {
          this.$ga.event({
            eventCategory: "dashboard-course-editor",
            eventAction: "add-day",
            eventLabel: "Dashboard"
          });
        } catch (err) {
          console.error("[GA]", err);
        }
        // End GA Analytics
      } catch (err) {
        alert(
          "Could not add day.\n\nAre you using the right editor? This can happen if the course was published while editing it as a draft."
        );
        console.error(err);
      }
      this.$store.commit("setLoading", false);
    },
    /**
     * Triggers the modal to be shown, also sets the day to the delete variable.
     */
    onDayDeleteAsk(day) {
      this.selectedDeleteDay = day;
      this.deleteDayModal = true;
    },
    /**
     * Resets the selected deleted day, also removes the modal.
     */
    async onDayDeleteReject() {
      this.selectedDeleteDay = null;
      this.deleteDayModal = false;
    },
    /**
     * Handles deleting the selected day on confirm
     */
    async onDayDeleteConfirm() {
      this.$store.commit("setLoading", true);
      this.deleteDayModal = false;
      try {
        await services.day.delete({
          id: this.courseid,
          did: String(this.selectedDeleteDay._id),
          type: this.type
        });
        //get the index of the day
        let delindex = -1;
        /**
         * @type {Array}
         */
        this.days.forEach((day, index) => {
          if (String(day._id) === String(this.selectedDeleteDay._id)) {
            delindex = index;
          }
        });
        if (
          String(this.selectedday._id) === String(this.selectedDeleteDay._id)
        ) {
          this.selected = null;
        }
        this.days.splice(delindex, 1);

        console.log("Deleted Day");
        //force an order correction
        let order_fix = await this.correctDayOrder();

        //force save the order correction, deletions cannto be undone, so correcting the order is required.
        this.$emit("save", order_fix);
        await this.onDayDeleteReject(); // clears the delete fields
        // GA Analytics
        try {
          this.$ga.event({
            eventCategory: "dashboard-course-editor",
            eventAction: "delete-day",
            eventLabel: "Dashboard"
          });
        } catch (err) {
          console.error("[GA]", err);
        }
        // End GA Analytics
      } catch (err) {
        this.$store.commit("setLoading", false);
        this.dayDeleteErrorModal = true;
        this.onDayDeleteReject();
        console.error("Delete error", err);
        // GA Analytics
        try {
          this.$ga.event({
            eventCategory: "dashboard-course-editor",
            eventAction: "delete-day-error",
            eventLabel: "Dashboard"
          });
        } catch (err) {
          console.error("[GA]", err);
        }
        // End GA Analytics
      }
      this.$store.commit("setLoading", false);
    },
    /**
     * Corrects the days order in the list.
     */
    async correctDayOrder() {
      let diff = [];
      this.days.forEach((day, index) => {
        if (day.day !== index + 1) {
          diff.push({ _id: day._id, day: index + 1 });
        }
        day.day = index + 1;
      });
      return diff;
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>
<style scoped>
.temp-textarea {
  width: 100%;
  border: 2px solid rgba(0, 0, 0, 0.12);
  border-radius: 2px;
}
#editor {
  display: flex;
}
.column.left {
  width: 230px;
  flex: 0 0 230px;
}
.button {
  margin-top: 35px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5 !important;
  color: white !important;
  background-color: #2196f3 !important;
}
.list-group-item .handle {
  cursor: move;
}
/* .list-group-item .icon {
    opacity: 0;
} */
.list-group-item:hover {
  cursor: pointer !important;
  background-color: rgb(240, 240, 240);
}
.trash:hover {
  color: red;
}
.icons {
  font-size: 10px !important;
}
.sidebar {
  overflow-y: auto;
}
</style>
